/**
 * スワイプが左右どちら方向か判定し、コールバックを実行
 * @param {DOM} スワイプ判定を行いたいHTMLのDOM要素
 * @param {Function} コールバック関数
 * @param {Boolean} transformでtouchmove中に要素を左右にずらすかどうか
 */
const setSwipe = function($target, callback, slideTransform) { // eslint-disable-line
  const _this = this; // eslint-disable-line

  if (!$target) return;

  _this.$container = $target;

  if (!callback) return;
  _this.callback = callback;

  _this.start = {
    point: null,
    time: null,
  };

  _this.diff = {
    point: null,
    time: null,
  };

  _this.stopper = false;
  _this.timeout = null;

  _this.slideTransform = slideTransform;

  _this.init();
};

setSwipe.prototype.init = function(valid) { // eslint-disable-line
  const _this = this; // eslint-disable-line
  _this.setEvent('ontouchstart' in window);
};

setSwipe.prototype.setEvent = function(valid) { // eslint-disable-line
  const _this = this; // eslint-disable-line

  // event
  const name = valid ? 'addEventListener' : 'removeEventListener';
  _this.$container[name]('touchstart', _this.touchstart, false);
  _this.$container[name]('touchmove', _this.touchmove, false);
  _this.$container[name]('touchend', _this.touchend, false);
  _this.$container.eventParam = _this;
};

setSwipe.prototype.touchstart = function(e) { // eslint-disable-line
  const _this = e.currentTarget.eventParam; // eslint-disable-line
  if (!_this.start.point && !_this.stopper) {
    _this.start.time = new Date();
    _this.start.point = e.touches[0].pageX;
    if (_this.slideTransform) e.currentTarget.style.removeProperty('-webkit-transition');
  }
};

setSwipe.prototype.touchmove = function(e) { // eslint-disable-line
  const _this = e.currentTarget.eventParam; // eslint-disable-line
  if (_this.start.point && !_this.stopper) {
    _this.diff.point = e.touches[0].pageX - _this.start.point;
    if (_this.slideTransform)
      e.currentTarget.style.setProperty(
        '-webkit-transform',
        `translate3d(${_this.diff.point}px, 0, 0)`,
      );
    e.preventDefault();
  }
};

setSwipe.prototype.touchend = function(e) { // eslint-disable-line
  const _this = e.currentTarget.eventParam; // eslint-disable-line

  const act_cancel = function() { // eslint-disable-line
    if (_this.slideTransform) e.currentTarget.style.removeProperty('-webkit-transform');
    _this.stopper = false;
    clearTimeout(_this.timeout);
  };

  if (_this.start.point && !_this.stopper) {
    const now = new Date();
    _this.diff.time = now - _this.start.time;
    if (_this.slideTransform)
      _this.$container.style.setProperty(
        'transition',
        `-webkit-transform ${_this.slideTransform}ms`,
      );

    if (_this.diff.time > 200 || Math.abs(_this.diff.point) > 60) {
      _this.stopper = true;
      _this.timeout = setTimeout(() => {
        _this.stopper = false;
        clearTimeout(_this.timeout);
      }, 200 + 75);
      /**
       * @param {Number} スワイプ方向
       * -> -1
       * <- 1
       */
      _this.callback.call(_this, _this.diff.point < 0);
    } else act_cancel();
  } else act_cancel();
  _this.diff.point = 0;
  _this.start.point = null;
};

// EXPORT
export default ($target, callback, slideTransform) =>
  new setSwipe($target, callback, slideTransform); // eslint-disable-line
